import React from 'react';

function SystemInfo({ system, formatUptime }) {
  if (!system) return null;
  const loadavg = Array.isArray(system.loadavg) ? system.loadavg : [];

  return (
    <div style={{ background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16 }}>
      <h3 style={{ color: '#e5e7eb', marginTop: 0, marginBottom: 12, fontSize: 18 }}>System</h3>
      <div style={{ display: 'grid', gap: 8 }}>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Platform</div>
          <div style={{ color: '#e5e7eb' }}>{system.platform} {system.arch}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Hostname</div>
          <div style={{ color: '#e5e7eb' }}>{system.hostname}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Uptime</div>
          <div style={{ color: '#e5e7eb' }}>{formatUptime(system.uptime)}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>CPU</div>
          <div style={{ color: '#e5e7eb' }}>{system.cpus}x {system.cpuModel}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Load (1/5/15m)</div>
          <div style={{ color: '#e5e7eb' }}>{loadavg.map((l) => Number(l).toFixed(2)).join(' / ')}</div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(SystemInfo);
